import { useBackend } from "../../services";

export const useGetSellValueProducts = () => {
  const { get } = useBackend();
  const getSellValueProducts = () => get("products/sellValues");
  return { getSellValueProducts };
};
